import { FeatureModule } from '@store/features/types';

export const userPreferences: FeatureModule = {
  id: 'userPreferences',
  name: 'User Preferences',

  dependencies: [], // No dependencies

  reducers: {}, // No client state slice as requested

  middleware: [], // RTK Query middleware is already registered at the store level via baseApi

  // No persistence needed as all state is managed by RTK Query cache
  persistence: {
    enabled: false,
  },

  // No sync needed as this is user-specific data
  sync: {
    enabled: false,
  },

  setup: store => {
    console.log(`${userPreferences.name} feature initialized`);
  },

  cleanup: store => {
    console.log(`${userPreferences.name} feature cleaned up`);
  },
};
